import { format, isValid, parse, parseISO } from "date-fns";
import { determineCultureFormat, formatCurrntDateTime, formatDateWithTime, FormatInvoiceDecimalNumber } from "../../../common/timeLiveFunction";

const tryParseDate = (value: string) => {
    const formats = [
        'MMM d yyyy h:mma',
        'MMM d yyyy h:mm a',
        'MMM d yyyy H:mm',
        'MMM d yyyy H:m',
        'MMM d yyyy h:mm',
        'MMM d yyyy h:m'
    ];

    for (const fmt of formats) {
        const parsed = parse(value, fmt, new Date());
        if (isValid(parsed)) return parsed;
    }

    const iso = parseISO(value);
    return isValid(iso) ? iso : null;
};

const detectValueType = (value: any) => {
    if (!value || value === '') return 'TEXT';

    const strValue = String(value).trim();

    if (strValue === 'true' || strValue === 'false' || strValue === 'Yes' || strValue === 'No') {
        return 'BOOLEAN';
    }

    const datetimePattern = /\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}/;
    if (datetimePattern.test(strValue)) {
        return 'DATETIME';
    }

    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    if (datePattern.test(strValue)) {
        return 'DATE';
    }

    if (!isNaN(parseFloat(value)) && isFinite(value) &&
        !/[a-zA-Z]/.test(strValue) &&
        strValue !== '0' && strValue !== '1') {

        return 'NUMERIC';
    }

    return 'TEXT';
};

export const formatAuditValue = (value: any, fieldName: string, cultureInfoName: string, decimalPlaces: number) => {
    if (!value || value === '') return '';

    const name = fieldName ? fieldName.toString() : '';

    if (name.endsWith('Id') || name.endsWith('ID')) {
        return value;
    }

    let valueType = detectValueType(value);

    if (name.startsWith('Is')) {
        valueType = 'BOOLEAN';
    }

    if (name.includes('Amount') || name.includes('Hours') || name.includes('Rate') || name.includes('Cost')) {
        valueType = 'NUMERIC';
    }

    if (name.includes('Date') || name.includes('On') || name.includes('Time')) {
        const normalizedValue = String(value).replace(/\s+/g, ' ').trim();
        // const parsedDate = parse(normalizedValue, 'MMM d yyyy h:mma', new Date());
        const parsedDate = tryParseDate(normalizedValue);
        if (/\d{4}-\d{2}-\d{2}/.test(String(value))) {
            valueType = value.includes('T') || value.includes(':') ? 'DATETIME' : 'DATE';
        } else if (isValid(parsedDate)) {
            valueType = 'DATETIME';
        } else {
            valueType = 'TEXT';
        }
    }

    switch (valueType) {
        case 'BOOLEAN':
            const strVal = String(value).toLowerCase();
            return (strVal === '1' || strVal === 'true' || strVal === 'yes') ? 'Yes' : 'No';

        case 'DATETIME':
            try {
                const normalizedValue = String(value).replace(/\s+/g, ' ').trim();
                // let parsedDate = parse(normalizedValue, 'MMM d yyyy h:mma', new Date());
                let parsedDate = tryParseDate(normalizedValue);

                if (!isValid(parsedDate)) {
                    parsedDate = parseISO(value);
                }

                if (!isValid(parsedDate)) return value;

                return formatCurrntDateTime(parsedDate, cultureInfoName.toString());
            } catch {
                return value;
            }

        case 'DATE':
            try {
                const parsedDate = parseISO(value);
                if (!isValid(parsedDate)) return value;
                return format(parsedDate, determineCultureFormat(cultureInfoName.toString()));
            } catch {
                return value;
            }

        case 'NUMERIC':
            const numValue = parseFloat(value);
            if (isNaN(numValue)) return value;

            const decimalCount = (name.includes('Hours') || name.includes('TotalTime')) ? 2 : decimalPlaces;
            return FormatInvoiceDecimalNumber(cultureInfoName.toString(), numValue, decimalCount);

        case 'TEXT':
        default:
            return value;
    }
};